import React, { useState } from "react";
import _ from "lodash";
import { useController, Controller } from "react-hook-form";


export const InputField = React.forwardRef((props, ref) => {
  const { field } = useController(props);
  const [focusState, setFocusState] = useState(false);
  const { title, style, isHighLight = false, type, errors, defaultValue, customStyle, onChange, ellipses, isDisabled=false, autoComplete = "", ...others } = props;
  let err = _.get(errors, props.name)
  return (

    <div className="w-full relative">
      <div className={`${customStyle ? customStyle : 'h-[35px]'}  relative w-full border border-gray ${style ? 'bg-white' : ''} bg-white focus-within:bg-white outlineStyle rounded ${props?.rules && err ? "focus-within:border-red-600 border-red-600" : "focus-within:border-teal-c-900"}`}>
        <Controller
          name={props?.name}
          control={props?.control}
          rules={props?.rules}
          defaultValue={defaultValue}
          render={({ field }) => (
            <input
              {...props}
              {...field}
              onBlurCapture={() => setFocusState(false)}
              onFocus={() => setFocusState(true)}
              onChange={e => {
                field.onChange(e.target.value);
                if (props.onChange) {
                  props.onChange(e, props?.name);
                }
              }}
              min={type === "number" && !props.min ? 0 : props.min}
              disabled={isDisabled ? isDisabled :false}
              placeholder={props.placeholder ? props.placeholder : ''}
              value={field.value}
              autoComplete={autoComplete === "off" ? "off" : autoComplete}
              autoCorrect={autoComplete === "off" ? "off" : undefined}
              autoCapitalize={autoComplete === "off" ? "off" : undefined}
              className={`block ${props.inputWidthCls ? props.inputWidthCls : 'w-full'} ${type === 'color' ? "h-full" : "p-1"} appearance-none focus:outline-none focus:ring-0 text-base font-light text-black-300 ${isDisabled ? "bg-gray-100 cursor-not-allowed" : "bg-transparent"}  ${isHighLight && " bg-highLight  "}  `} {...others}/>
          )}
        />
        <div
          className={`pointer-events-none absolute ml-2 left-0 duration-300 origin-0 mr-2 inline-block px-1 font-normal  ${props?.rules && err ? "text-red-600" : "text-gray-600"}  ${focusState || !field.value == "" || field.value == "0"
            ? "-top-2 duration-300 bg-[white] text-xs rounded-lg"
            : `top-2 duration-300 text-base xl:top-1 ${ellipses && 'w-[98%] text-ellipsis overflow-hidden whitespace-nowrap'}`
            } 
            ${isHighLight && " bg-highLight  "}  
            `}
        >
          {title} {props?.rules?.required?.value === true && <span className="text-red-500 mt-10">*</span>}
        </div>

      </div>
      {props.rules && err &&
        <div className="absolute">
          <p className="text-xs text-red-600 h-3 text-left" id="email-error">
            {props.rules && err && props.rules && err?.message}
          </p>
        </div>
      }
    </div>
  );
});